<template>
  <footer class="footer" id="footer">
    <div class="container">
      <div class="row d-flex flex-column flex-md-row justify-content-between align-items-center">
        <!-- Политика обработки данных -->
        <div class="d-block d-md-block order-2 order-md-1 col-12 col-md-4 text-center text-md-start">
          <div class="">
            <p class="" style="margin-top: 4px">
              <!-- {{ new Date().getFullYear() }} © All Rights Reserved -->
                <a style="color:inherit;text-decoration: none;" href="https://taganrog.pro100quiz.ru/privacy_policy">Политика обработки персональных данных</a>
                <br>
                <a style="color:inherit;text-decoration: none;" href="https://taganrog.pro100quiz.ru/personal_data_consent">Соглаcие на обработку данных</a>
            </p>
          </div>
          <!-- separator after policies (mobile only) -->
          <div class="d-block d-md-none col-12">
            <div class="separator" style="height: 1px; background: white; margin: 12px 0;opacity: 0.2;"></div>
          </div>
        </div>
        <div class="col-12 col-md-4 justify-content-center d-flex order-1 order-md-2">
          <div class="footerLogo">
<!--            <img v-if="common.logo" :src="glb.getMediaUrl(common.logo)" alt="">-->
            <img class="position-absolute" src="../../assets/media/logo.png" style="max-width: 86px"/>
            <div class="position-relative logoBackground"></div>
          </div>
        </div>
        <div class="d-flex d-md-flex order-3 order-md-3 col-12 col-md-4 justify-content-center justify-content-md-end">
          <div class="d-flex align-items-center">
            <img class="" src="../../assets/media/soc_icon_04_instagram.svg" />
            <p style="margin-left: 8px;margin-top: 4px">+79934516288</p>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  name: "MainFooter",
  props: ['common'],
}
</script>

<style scoped>
.footer {
  background: radial-gradient(100% 9772.83% at 50% 58.74%, rgba(252, 166, 217, 0.45) 0%, rgba(62, 63, 139, 0) 52.88%);
}
.footerLogo {
  padding-top: 1.5rem;
}
.logoBackground {
  width: 5.5rem;
  height: 5.5rem;
  background: rgba(213,35,136,.3);
  filter: blur(4rem);
}
</style>
